/* Scroll-triggered reveal animations for the PDP.
   Elements marked [data-reveal] start hidden (opacity 0 + slight lift) and
   animate in when they enter view. Elements also marked [data-reveal-immediate]
   are above-the-fold and reveal on load (no scroll needed). Optional per-element
   delay via [data-reveal-delay="ms"]. Containers marked [data-reveal-stagger]
   cascade their [data-reveal] children automatically. Respects reduced-motion. */
(function () {
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Announce that reveal is active — CSS gates the hidden state on this class,
  // so if the script never runs, elements stay visible (safety net).
  document.documentElement.classList.add('pdp-250-reveal-active');

  function applyDelay(el) {
    var delay = el.getAttribute('data-reveal-delay');
    if (delay) el.style.setProperty('--reveal-delay', delay + 'ms');
  }

  // Stagger children in containers marked [data-reveal-stagger] (only for
  // children that don't have their own explicit delay).
  document.querySelectorAll('[data-reveal-stagger]').forEach(function (container) {
    var children = container.querySelectorAll('[data-reveal]');
    children.forEach(function (child, i) {
      if (!child.getAttribute('data-reveal-delay')) {
        child.style.setProperty('--reveal-delay', (i * 180) + 'ms');
      }
    });
  });

  // Above-the-fold elements: reveal immediately after DOM paint.
  var immediateEls = document.querySelectorAll('[data-reveal-immediate]');
  immediateEls.forEach(applyDelay);
  requestAnimationFrame(function () {
    immediateEls.forEach(function (el) { el.classList.add('is-revealed'); });
  });

  // Everything else: wait for IntersectionObserver (or reveal immediately on
  // reduced-motion / no-IO browsers).
  var scrollEls = document.querySelectorAll('[data-reveal]:not([data-reveal-immediate])');
  if (!scrollEls.length) return;
  scrollEls.forEach(applyDelay);

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    scrollEls.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });

  scrollEls.forEach(function (el) { obs.observe(el); });
})();
